import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';
import { GET_BENEFITS_GAMEFICATION, GET_BENEFITS_GAMEFICATION_SUCCESS, GET_BENEFITS_GAMEFICATION_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getBenefitsGamification({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/get-client-inventories`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFITS_GAMEFICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFITS_GAMEFICATION_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFITS_GAMEFICATION_ERROR, payload: error });
  }
}

export function* watchgetBenefitsGamification() {
  yield takeEvery(GET_BENEFITS_GAMEFICATION, getBenefitsGamification);
}

function* getBenefitsGamificationSaga() {
  yield all([fork(watchgetBenefitsGamification)]);
}

export default getBenefitsGamificationSaga;
